<template>
  <v-container pa-0 ma-0>
    <v-list class="title">
      <v-list-tile class="font-italic title">
        <v-list-tile-avatar class="caption">{{ $t('$vuetify.Inspections.number') }}</v-list-tile-avatar>
        <v-list-tile-title class="caption">{{ $t('$vuetify.Inspections.name') }}</v-list-tile-title>
        <v-list-tile-action class="caption">{{ $t('$vuetify.Inspections.resolution') }}</v-list-tile-action>
        <v-list-tile-avatar class="justify-end caption">{{ $t('$vuetify.Inspections.download') }}</v-list-tile-avatar>
      </v-list-tile>
      <v-divider></v-divider>
      <v-list-tile
        class="caption"
        v-for="(attachment, index) in attachments"
        :key="index"
        @click="buttonLogic(attachment)"
      >
        <v-list-tile-avatar class="caption">{{ index + 1 }}.</v-list-tile-avatar>
        <v-list-tile-title v-text="attachment.name || attachment.FILENAME"></v-list-tile-title>
        <v-list-tile-action
          v-text="attachment.FILETYPE"
          :style="$vuetify.breakpoint.xsOnly ? 'min-width: 30px; font-size: 10px' : 'padding-left: 5px'"
        ></v-list-tile-action>
        <v-list-tile-avatar class="justify-end">
          <v-btn
            id="urlButton"
            icon
            @click.native.stop="downloadAttachment(attachment)"
          >
            <v-icon size="18px">fa-download</v-icon>
          </v-btn>
        </v-list-tile-avatar>
      </v-list-tile>
    </v-list>
    <v-dialog v-model="attachmentDialog" fullscreen hide-overlay lazy>
      <v-card>
        <v-toolbar dark dense color="blue">
          <v-btn icon dark @click="attachmentDialog = false" extended :extension-height="7">
            <v-icon>close</v-icon>
          </v-btn>
          <v-progress-linear slot="extension" v-if="loading" :indeterminate="loading" ma-0></v-progress-linear>
        </v-toolbar>
        <swiper :options="swiperOption" style="height: 95vh">
          <swiper-slide
            v-for="(attachment, index) in filteredAttachments"
            :key="index"
            style="display:flex"
          >
            <img :src="attachment.filePath" class="slider" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </v-card>
    </v-dialog>
    <v-dialog v-model="videoDialog" @click="videoDialog = false">
      <v-card class="text-xs-center transparent ma-0 pa-0" style="box-shadow: none!important">
        <v-card-title class="justify-center mb-0 pb-0">
          <v-btn
            icon
            @click="videoDialog = false"
            >
              <v-icon size="40px">cancel</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text @click="videoDialog = false" class="pa-0">
          <video :src='videoPath' controls autoplay :style="$vuetify.breakpoint.xsOnly ? 'max-width: 99% ; width: 90%' : 'max-width: 80%'" style="max-height: auto"></video>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { mapActions } from 'vuex'

const imageFormats = ['png', 'jpeg', 'jpg'];
const videoFormats = ['mov', 'mp4', 'm4v']

export default {
  name: 'AttachmentForm',
  components: {
    swiper,
    swiperSlide
  },
  props: {
    attachments: Array
  },
  mounted () {
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) this.ios = true
  },
  data() {
    return {
      ios: false,
      videoPath: '',
      videoDialog: false,
      clickControl: false,
      attachmentDialog: false,
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  methods: {
    ...mapActions(['downloadAttachment']),
    buttonLogic(attachment) {
      if (
        attachment.FILETYPE && imageFormats.includes(attachment.FILETYPE.toLowerCase())
      ) {
        this.attachmentDialog = true
      } else if(!this.ios && attachment.FILETYPE && videoFormats.includes(attachment.FILETYPE.toLowerCase())){
        this.videoPath = attachment.filePath
        this.videoDialog = true
      } else {
        this.downloadButton()
      }
    },
    downloadButton() {
      document.getElementById('urlButton').click()
    }
  },
  computed: {
    loading() {
      return this.$store.state.base.loading
    },
    filteredAttachments() {
      return this.attachments && this.attachments.length
        ? this.attachments.filter(attachment =>
          attachment.FILETYPE && imageFormats.includes(attachment.FILETYPE.toLowerCase())
        )
        : []
    }
  }
}
</script>

<style scope>
.slider {
  min-width: 10vw;
  min-height: 10vh;
  max-height: 95vh;
  max-width: 100vw;
  margin: auto;
}
.swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  height: 20px;
  width: 20px;
}
.v-dialog {
  box-shadow: none;
}
</style>